import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    tripList: [],
    tripById: {},
    loading: false,
    error: false,
    errorMessage: "",
};

const RealTimeTripSlice = createSlice({
    name: "realTimeTrip",
    initialState,
    reducers: {
        getTripList(state, action) {
            state.tripList = action.payload;
            state.loading = false;
            state.error = false;
        },
        getTripById(state, action) {
            state.tripById = action.payload;
            state.loading = false;
            state.error = false;
        },
        loadingData(state, action) {
            state.loading = action.payload;
        },
        errorMessages(state, action) {
            state.error = true;
            state.errorMessage = action.payload;
            state.loading = false;
        },
        clearError(state) {
            state.error = false;
            state.errorMessage = "";
        },
        clearTripData(state) {
            state.tripList = [];
            state.tripById = {};
        },
    },
});

export const {
    getTripList,
    getTripById,
    loadingData,
    errorMessages,
    clearError,
    clearTripData,
} = RealTimeTripSlice.actions;

export default RealTimeTripSlice.reducer;
